import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import cartItemsReducer from './cartItemsReducer';
import emptyReducer from '../../common/reducers/EmptyReducer';
import { connectRouter } from 'connected-react-router';

const reducers = {
  userId: emptyReducer,
  cartItems: cartItemsReducer,
  shoppingData: emptyReducer,
  deviceType: emptyReducer,
  srcId: emptyReducer,
  appDefId: emptyReducer,
  consentPolicy: emptyReducer,
  site: emptyReducer,
  routing: routerReducer
};

export default history => combineReducers({
  router: connectRouter(history),
  location: emptyReducer,
  ...reducers
});
